const INFO = {
	main: {
		title: "Porfolio by mushahid hussain",
		name: "Mushahid Hussain.",
		email: "mushahidhussain462@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/mushahidhussain1",
		linkedin: "https://www.linkedin.com/in/agha-mushahid-hussain/",
		instagram: "https://www.instagram.com/agha_mushahid_hussain/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full-stack web developer with expertise in Core PHP and Laravel, and amateur astronaut.",
		description:
			"I am a backend developer with expertise in PHP and Laravel. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Mushahid Hussain. I live in Pakisatan, where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Books Library System Websit",
			description:
				"A modern Books Library System website with restricted access for admins to manage books, users, and library data.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/php/php.png",
			linkText: "View Project",
			link: "https://github.com/mushahidhussain1/library-system",
		},

		{
			title: "Super Market Website",
			description:
				"A Supermarket e-commerce website to showcase products and enable online shopping.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/php/php.png",
			linkText: "View Project",
			link: "https://github.com/mushahidhussain1/shopping-project",
		},

		{
			title: "Crud Operations in Core PHP",
			description:
				"simple CRUD application designed and developed using PHP, allowing users to create, read, update, and delete data with a clean interface and functional backend logic",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/php/php.png",
			linkText: "View Project",
			link: "https://github.com/mushahidhussain1/crud",
		},

		{
			title: "Project 4",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 5",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},
	],
};

export default INFO;
